<template>
	<section class="app-container form-high-contrast">
		<div class="loading-overlay" v-show="loading">
			<div class="spinner-wrapper">
				<span class="spinner-text">LOADING</span>
				<span class="spinner"></span>
			</div>
		</div>
		<div class="container record-add" v-if="checklist != null">
			<div class="sticky-top clearfix pull-right">
				<div class="sticky-outter">
					<div class="sticky-inner top-save-button">
						<button class="btn btn--primary btn-sm type--uppercase" v-on:click="saveChecklist(false)">Save</button>
						<button class="btn btn--primary btn-sm type--uppercase" v-on:click="saveChecklist(true)">Save &amp; Exit</button>
						<button class="btn btn-danger btn-sm type--uppercase" v-on:click="deleteChecklist()" data-tooltip='Delete Checklist and all records'><i class="fa fa-trash"></i></button>
						<button class="btn btn-sm type--uppercase" v-on:click="cancel(true)">Cancel</button>
					</div>
				</div>
			</div>
			<h2 class="checklist_edit_heading">
				<span class="label label--inline" v-if="checklist.private">PRIVATE</span>
				Editing Checklist - <span v-if="checklist.datetime">{{checklist.datetime.split('T')[0] | moment(momentDisplayFormat())}}</span> @ <span class="notranslate" translate="no">{{checklist_location.display_name}}</span>
				<button class="btn btn--primary btn-xs" v-if="!editing_checklist" @click="editing_checklist = true">
					<i class="fa fa-pencil"></i> Edit Details
				</button>
			</h2>
			<h4 v-if="checklist.observer && !editing_checklist">Observed by <em>{{checklist.observer}}</em></h4>
			<h4 v-if="checklist.observer == '' && !editing_checklist">Observed by a third party</h4>
			<div class="card card-1 boxed boxed--sm boxed--border" v-show="editing_checklist">
				<strong>Editing Checklist Date, Time, &amp; Privacy</strong>
				<ChecklistEditControl v-model="checklist" :errors="checklist_errors" :current_user="checklist_current_user" @locationChanged="locationChanged" :showLocationEdit="true" />
			</div>
			<div>
				<hr>
				<button class="btn btn-xs pull-right" @click="iNatPopup()">Import Record(s) from iNaturalist</button>
				<div class="modal-container inat-import-modal" id="iNatImport">
					<div class="modal-content modal-content-regular">
						<div class="modal-close modal-close-cross"></div>
						<div class="bg--white border--round ">
							<div class="container">
								<h3>Enter iNaturalist Observation ID or URL</h3>
								<p><strong>This will import the species name and photos from the iNaturalist record.<br />You will then need to fill out the sighting details.</strong></p>
								<input v-model="iNatImportID" type="text">
								<button class="btn btn-block btn--primary" @click="iNatImport()">Import Record from iNaturalist</button>
							</div>
						</div>
					</div>
				</div>
				<h4>Add Sightings</h4>
				<ErrorField :errors="api_errors" field="non_field_errors" />

				<button v-on:click="addExtraSighting" class="btn btn-secondary">Add Species</button>
				<div class="visible-md visible-lg" v-if="extra_sightings != null && extra_sightings.length > 0">
					<div class="row row-header">
						<div class="col-md-4 ">
							<strong>Added Species</strong>
						</div>
						<div class="col-md-1 ">
							<strong>Count</strong>&nbsp;<i class="fa fa-info-circle" data-tooltip='Enter estimated or exact count or “X” for observed'></i>
						</div>
						<div class="col-md-4 ">
							<strong>ID Confidence</strong>&nbsp;<i class="fa fa-info-circle" data-tooltip='Indicate how confident you are in the ID of the species reported.  Report confidence for the best seen individual.'></i>
						</div>
						<div class="col-md-3">
							<button class="btn btn-expand-all btn-oc-xs pull-right" @click="toggleAll(true);"><i class="fa fa-plus-square"></i>&nbsp;Expand All</button>
							<button class="btn btn-expand-all btn-oc-xs pull-right" @click="toggleAll(false);"><i class="fa fa-minus-square"></i>&nbsp;Collapse All</button>
						</div>
					</div>
				</div>
				<div :class="'row row-entry row-entry-' + sighting.key + errorClass(sighting.api_index) " v-for="sighting in extra_sightings" :key="sighting.key">
					<div class="col-md-4" v-if="sighting.details.can_edit !== false">
						<TaxonSelector v-model="sighting.taxon" placeholder="Please Select a Taxon" />
					</div>
					<div class="col-md-1" v-if="sighting.details.can_edit !== false">
						<input v-model="sighting.details.count" :class="getExtraCountClass(sighting)" type="text" />
					</div>
					<div class="col-md-4 col-confidences" v-if="sighting.details.can_edit !== false">
						<span v-for="confidence in id_confidences">
							<div class="input-radio">
								<span class="input__label">{{confidence.name}}</span>
								<input :name="'extra' +sighting.key + 'confidence'" :id="'extra' +sighting.key + 'confidence-' + confidence.id" type="radio" :value="confidence.id" v-model="sighting.details.observer_confidence" />
								<label :for="'extra' +sighting.key + 'confidence-' + confidence.id" style="display: inline-block!important;top:10px;"></label>
							</div>
						</span>
					</div>
					<div class="col-md-3 col-details-buttons"  v-if="sighting.details.can_edit !== false">
						<a class="btn btn--sm show-details" v-show="sighting.details.count && sighting.details.count != ''" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Photos &amp; Details</a>
						<a class="btn btn--sm hide-details" v-show="sighting.details.count && sighting.details.count != ''" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Hide Details</a>
						<a class="btn btn--sm btn-danger pull-right" @click="removeExtraSighting(sighting)" data-tooltip='Delete Record'><i class="fa fa-trash"></i></a>
					</div>
					<div class="col-md-12" v-else>
						<span class="notranslate" translate="no">{{sighting.taxon.common_name}}</span>
						<span v-if="sighting.details.status == APIStatuses.accpeted" class="badge badge-success">Accepted</span>
						<span v-if="sighting.details.status == APIStatuses.declined" class="badge badge-danger">Declined</span>
						<div class="pull-right col-details-buttons">
							<a class="btn btn--sm btn-danger" @click="removeExtraSighting(sighting)" data-tooltip='Delete Record'><i class="fa fa-trash"></i></a>
						</div>
					</div>
					<div class="col-sm-12">
						<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="non_field_errors" />
					</div>
					<div class="col-md-12 entry-details" v-show="sighting.details.count && sighting.details.count != ''" v-if="sighting.details.can_edit !== false">
						<hr style="margin:5px 10px 10px;">
						<div class="row">
							<div class="col-md-12 col-life-stages">
								Life stage:
								<span v-for="life_stage in life_stages">
									<div class="input-radio">
										<span class="input__label">{{life_stage.name}}</span>
										<input :name="'extra' +sighting.key + 'life-stage'" :id="'extra' +sighting.key + 'life-stage-' + life_stage.id" type="radio" :value="life_stage.id" v-model="sighting.details.life_stage" />
										<label :for="'extra' +sighting.key + 'life-stage-' + life_stage.id" style="display: inline-block!important;top:10px;"></label>
									</div>
								</span>
								<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="life_stage" />
							</div>
							<div class="col-md-4">
								<div class="input-checkbox">
									<input :id="'checkboxextra' +sighting.key" type="checkbox" :name="sighting.details.specimen" v-model="sighting.details.specimen" />
									<label :for="'checkboxextra' +sighting.key"></label>
								</div>
								<span>Specimen <small>(must be checked for specimen records)</small></span>
							</div>
							<div class="col-md-8">
								<label>Institution <i class="fa fa-info-circle" data-tooltip='Required for specimen records. Name of institution where specimen is housed or indicate "Personal Collection"'></i></label>
								<input type="text" v-model="sighting.details.institution">
								<label>Specimen Notes <i class="fa fa-info-circle" data-tooltip='Enter any notes desired for any record type. Please enter any anticipated disposition changes of all specimens. Please enter any ID points for difficult species.'></i></label>
								<textarea v-model="sighting.details.notes"></textarea>
							</div>
							<div class="col-md-12">
								<br />
								<h4>Submit Photos (Please ensure all photos are tightly cropped):</h4>
								<ImageManager v-model="sighting.details.photos" :uniqueid="'file-upload-extra' +sighting.key"></ImageManager>
							</div>
							<div class="col-md-12">
								<div class="request-expert">
									<div class="input-checkbox">
										<input type="checkbox" name="request_expert" v-model="sighting.details.request_vetting" />
										<label for="request_expert"></label>
									</div>
									<span>I request expert vetting of this record</span>
								</div>
								<div class="pull-right">
									<a class="btn btn-clear">Clear</a>
									<a class="btn btn-close" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Close</a>
								</div>
							</div>
						</div>
							
						
					</div>
				</div>
				<div class="large-text-hr">
					<hr />
					<strong>
						OR
						<small>add from local species list</small>
					</strong>
				</div>
				<div class="visible-md visible-lg">
					<div class="row row-header">
						<div class="col-md-4 ">
							<strong>Local Species</strong>
						</div>
						<div class="col-md-1">
							<strong>Count</strong>&nbsp;<i class="fa fa-info-circle" data-tooltip='Enter estimated or exact count or “X” for observed'></i>
						</div>
						<div class="col-md-4 ">
							<strong>ID Confidence</strong>&nbsp;<i class="fa fa-info-circle" data-tooltip='Indicate how confident you are in the ID of the species reported.  Report confidence for the best seen individual.'></i>
						</div>
						<div class="col-md-3">
							<button class="btn btn-expand-all btn-oc-xs pull-right hidden-xs" @click="toggleAll(true);"><i class="fa fa-plus-square"></i>&nbsp;Expand All</button>
							<button class="btn btn-expand-all btn-oc-xs pull-right hidden-xs" @click="toggleAll(false);"><i class="fa fa-minus-square"></i>&nbsp;Collapse All</button>
						</div>
					</div>
				</div>
				<div :class="'row row-entry' + errorClass(sighting.api_index) " v-for="(sighting, index) in common_list" :key="sighting.taxon.id">
					<div class="col-md-12 col-taxon-divider notranslate" translate="no" v-if="index == 0 || showFamilyDivider(sighting, common_list[index - 1])">
						<em>{{sighting.taxon.family.scientific_name}} </em>({{sighting.taxon.family.common_name}})
					</div>
					<div class="col-md-4" v-if="sighting.details.can_edit !== false">
						<h5 class="species-title notranslate" translate="no"><em>{{sighting.taxon.scientific_name}}</em> ({{sighting.taxon.common_name}})</h5>
						<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="count" />
					</div>
					<div class="col-md-1" v-if="sighting.details.can_edit !== false">
						<input v-model="sighting.details.count" class="entry-count" type="text" />
					</div>
					<div class="col-md-4 col-confidences" v-if="sighting.details.can_edit !== false">
						<span v-for="confidence in id_confidences">
							<div class="input-radio">
								<span class="input__label">{{confidence.name}}</span>
								<input :name="sighting.taxon.id + 'confidence'" :id="sighting.taxon.id + 'confidence-' + confidence.id" type="radio" :value="confidence.id" v-model="sighting.details.observer_confidence" />
								<label :for="sighting.taxon.id + 'confidence-' + confidence.id" style="display: inline-block!important;top:10px;"></label>
							</div>
						</span>
					</div>
					<div class="col-md-3 col-details-buttons" v-show="sighting.details.count && sighting.details.count != ''" v-if="sighting.details.can_edit !== false">
						<a class="btn btn--sm show-details" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Photos &amp; Details</a>
						<a class="btn btn--sm hide-details" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Hide Details</a>
						<a class="btn btn--sm btn-danger pull-right" @click="removeCommonSighting(sighting)" data-tooltip='Delete Record'><i class="fa fa-trash"></i></a>
					</div>
					<div class="col-md-12" v-else>
						<h5 class="species-title notranslate" translate="no" style="display:inline"><em>{{sighting.taxon.scientific_name}}</em> ({{sighting.taxon.common_name}})</h5>
						<span v-if="sighting.details.status == APIStatuses.accpeted" class="badge badge-success">Accepted</span>
						<span v-if="sighting.details.status == APIStatuses.declined" class="badge badge-danger">Declined</span>
						<div class="pull-right col-details-buttons">
							<a class="btn btn--sm btn-danger" @click="removeExtraSighting(sighting)" data-tooltip='Delete Record'><i class="fa fa-trash"></i></a>
						</div>
					</div>
					<div class="col-sm-12">
						<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="non_field_errors" />
					</div>
					<div class="col-md-12 entry-details" v-show="sighting.details.count && sighting.details.count != ''" v-if="sighting.details.can_edit !== false">
						<hr style="margin:5px 10px 10px;">
						<div class="row">
							<div class="col-md-12 col-life-stages">
								Life stage:
								<span v-for="life_stage in life_stages">
									<div class="input-radio">
										<span class="input__label">{{life_stage.name}}</span>
										<input :name="sighting.taxon.id + 'life-stage'" :id="sighting.taxon.id + 'life-stage-' + life_stage.id" type="radio" :value="life_stage.id" v-model="sighting.details.life_stage" />
										<label :for="sighting.taxon.id + 'life-stage-' + life_stage.id" style="display: inline-block!important;top:10px;"></label>
									</div>
								</span>
								<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="life_stage" />
							</div>
							<div class="col-md-4">
								<div class="input-checkbox">
									<input :id="'checkbox' + sighting.taxon.id" type="checkbox" :name="sighting.details.specimen" v-model="sighting.details.specimen" />
									<label :for="'checkbox' + sighting.taxon.id"></label>
								</div>
								<span>Specimen <small>(must be checked for specimen records)</small></span>
							</div>
							<div class="col-md-8">
								<label>
									Institution
									<strong v-if="sighting.details.specimen"> *(required for specimen records)</strong>
									<i class="fa fa-info-circle" data-tooltip='Required for specimen records. Name of institution where specimen is housed or indicate "Personal Collection"'></i>
								</label>
								<input type="text" v-model="sighting.details.institution">
								<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="institution" />
								<label>Notes <i class="fa fa-info-circle" data-tooltip='Enter any notes desired for any record type. Please enter any anticipated disposition changes of all specimens. Please enter any ID points for difficult species.'></i></label>
								<textarea v-model="sighting.details.notes"></textarea>
								<ErrorField :errors="api_errors.sightings[sighting.api_index]" field="notes" />
							</div>
							<div class="col-md-12">
								<br />
								<h4>Submit Photos (Please ensure all photos are tightly cropped):</h4>
								<ImageManager v-model="sighting.details.photos" :uniqueid="'file-upload-' + sighting.taxon.id"></ImageManager>
							</div>
							<div class="col-md-12">
								<div class="request-expert">
									<div class="input-checkbox">
										<input type="checkbox" name="request_expert" v-model="sighting.details.request_vetting" />
										<label for="request_expert"></label>
									</div>
									<span>I request expert vetting of this record</span>
								</div>
								<div class="pull-right">
									<a class="btn btn-close" onclick="$(this).closest('.row-entry').toggleClass('detailsIn');">Close</a>
								</div>
							</div>
						</div>
							
						
					</div>
				</div>
				<hr>
				<div class="row">
					<div class="col-md-8">
						<button class="btn btn--primary btn-block type--uppercase" v-on:click="saveChecklist(false)">Save</button><br />
					</div>
					<div class="col-md-4">
						<button class="btn btn-block type--uppercase" v-on:click="saveChecklist(true)">Save &amp; Exit</button>
					</div>
					<div class="col-md-4 offset-md-8">
						<button class="btn btn-block btn-danger type--uppercase" v-on:click="deleteChecklist()">Delete Checklist &amp; Records</button>
					</div>
				</div>
			</div>
			
		</div>
		<ModalYesNo ref="deleteModalYesNo" uniqueID="deleteModalYesNo" title="Empty Checklist" text="Would you like to delete this empty checklist?" />
	</section>
</template>

<script>
import axios from 'axios';
export default {
	name: 'ChecklistEditComponent',
	metaInfo: {
      title: 'Edit Checklist & Sightings',
    },
	data: function(){
		return {
			checklist_user: null,
			checklist_location: null,
			checklist: null,
			common_list: null,
			extra_sightings: null,
			life_stages:null,
			id_confidences:null,
			api_errors:{
				'sightings': []
			},
			form_dirty:false,
			editing_checklist: false,
			checklist_errors: {},
			checklist_current_user: null,
			iNatImportID: this.$route.query.inatrecord,
			loading:false,
		};
	},
	created() {
		window.addEventListener('beforeunload', this.onBeforeUnload)
	},

	beforeDestroy() {
		window.removeEventListener('beforeunload', this.onBeforeUnload)
	},
	beforeRouteLeave (to, from, next) {
		// If the form is not dirty or the user confirmed they want to lose unsaved changes,
		// continue to next view
		if (!this.form_dirty || this.confirmLeave()){
			next()
		} else {
			// Cancel navigation
			next(false)
		}
	},
	mounted: function(){
		var self = this;
		this.bindChecklist(function(){
			if (self.iNatImportID) {
				self.iNatImport();
				let query = Object.assign({}, self.$route.query);
				delete query.inatrecord;
				self.$router.replace({ query });
			}
		});
		this.API({
			endpoint: 'life-stages',
			funcThen: function(response){
				self.life_stages = response.data.life_stages;
			},
		});
		this.API({
			endpoint: 'id-confidences',
			funcThen: function(response){
				self.id_confidences = response.data.id_confidences;
			},
		});
	},
	watch:{
		'extra_sightings': {
			handler(newVal){
				this.form_dirty = true;
			},
			deep: true
		},
		'common_list': {
			handler(newVal){
				this.form_dirty = true;
			},
			deep: true
		}
	},
	methods:{
		HasINatDateMismatch: function(sighting){
			if (!sighting.iNatDate) {
				return false;
			}

			if (this.checklist.datetime.startsWith(sighting.iNatDate)) {
				return false;
			}
			return true;
		},
		HasINatLocationMismatch: function(sighting){
			var fuzz = 0.21;
			if (!sighting.iNatLat || !sighting.iNatLng) {
				return false;
			}

			if (
				sighting.iNatLat > this.checklist_location.latitude + fuzz ||
				sighting.iNatLat < this.checklist_location.latitude - fuzz ||
				sighting.iNatLng < this.checklist_location.longitude - fuzz ||
				sighting.iNatLng > this.checklist_location.longitude + fuzz
			) {
				return true;
			}
			return false;

		},
		iNatImport: function(){
			var workingid = this.iNatImportID;
			if (workingid.lastIndexOf('/') > -1) {
				var wsplit = workingid.split('/');
				workingid = wsplit[wsplit.length - 1];
			}
			workingid = parseInt(workingid);
			if (isNaN(workingid) || workingid < 1) {
				this.$notify({
					text: 'Please enter a valid iNaturalist ID or URL.',
					type: 'error',
				});
				return;
			}
			this.iNatImportID = workingid;
			mr.modals.closeActiveModal();
			var self = this;
			self.loading = true;
			this.iNatAPI({
				endpoint: 'observations/' + workingid,
				funcThen: function(response){
					self.processiNatRecord(response.data.results[0]);
				},
				funcCatch: function(error){
					console.log(error);
				},
			});
		},
		getCSVCoords: function (location){
			if (location.indexOf(',') < 0) {
				return null;
			}
			var splitLocation = location.split(',');
			if (isNaN(splitLocation[0]) || isNaN(splitLocation[1])) {
				return null;
			}
			return {
				"lat": parseFloat(splitLocation[0]),
				"lng": parseFloat(splitLocation[1]),
			}
		},
		getNameFromINatRecord: function(record){
			return record.taxon.name;
		},
		processiNatRecord: function(record){
            var self = this;
			var sci_name = this.getNameFromINatRecord(record);
			var found_taxon = null;
            var allPromises = [];
            var photos = [];

            var iNatLocation = this.getCSVCoords(record.location);
            var iNatDate = record.observed_on_details.date;

            for (var i = 0; i < record.photos.length; i++) {
            	var photo = record.photos[i];
            	var photo_url = photo.url.replace("/square.", "/original.");
            	allPromises.push(this.API({
	                endpoint: 'sighting-photos',
	                postData: {"url":photo_url},
	                isPost:true,
	                funcThen: function(response){
	                	photos.push(self.api_photo_to_vue(response.data.sighting_photo));
	                }
	            }));
            }

            if (!sci_name || sci_name.trim().indexOf(" ") == -1) {
            	sci_name = "Anisoptera Unknown Dragonfly Species";
            }

        	allPromises.push(this.API({
                endpoint: 'taxa',
                querystring: "&search="+ encodeURI(sci_name),
                funcThen: function(response){
                	if (response.data.taxa && response.data.taxa.length > 0) {
                		found_taxon = response.data.taxa[0];
                	}
                }
            }));

			

            axios.all(allPromises).then(function(){
            	var key = Math.floor(Math.random() * 100000000);
            	var pushing = {
				    "key": key,
				    "details": {
				        "specimen": false,
				        "photos": photos,
				        "observer_confidence": 1,
				        "life_stage": 1,
				        "needs_count": false,
				        "count": "X",
				        "notes": "Imported from iNaturalist record #" +record.id+".\nhttps://www.inaturalist.org/observations/" +record.id+"",
				    },
				    "taxon": found_taxon,
				    "iNatLat": "woot",
				    "iNatLng": "woot",
				};
				if (iNatLocation) {
					pushing.iNatLat = iNatLocation.lat;
					pushing.iNatLng = iNatLocation.lng;
				}
				if (iNatDate) {
					pushing.iNatDate = iNatDate;
				}
				if (self.iNatImportID > 0) {
					pushing.inaturalist_id = self.iNatImportID;
					self.iNatImportID = null;
				}
				var push = true;
				if (self.HasINatLocationMismatch(pushing)) {
					self.$notify({
						title: 'iNatrualist Error',
						text: 'This iNaturalist record is from a different location and cannot be imported into this checklist.',
						type: 'error',
						duration: -1,
					});
					push = false;
				}
				if (self.HasINatDateMismatch(pushing)) {
					self.$notify({
						title: 'iNatrualist Error',
						text: 'This iNaturalist record is from a different date and cannot be imported into this checklist.',
						type: 'error',
						duration: -1,
					});
					push = false;
				}

				if (push) {
	            	self.extra_sightings.push(pushing);
					self.expand_sighting(key);
				}
				self.loading = false;
            });
		},
		expand_sighting: function(key){
			this.$nextTick(function () {
				$(".row-entry-" + key).addClass('detailsIn');
			});
		},
		iNatPopup: function(adding){
        	mr.modals.showModal($('#iNatImport'));
		},
		toggleAll: function(show){
			if (show) {
				$(".show-details:visible").closest('.row-entry').addClass('detailsIn');
			}
			else{
				$(".row-entry.detailsIn").removeClass('detailsIn');
			}
		},
		showFamilyDivider: function(sighting, previousSighting){
			return sighting.taxon.family.id != previousSighting.taxon.family.id;
		},
		locationChanged: function(newLocation){
			this.checklist_location = newLocation;
		},
		onBeforeUnload(e) {
			if (this.form_dirty && !this.confirmLeave()) {
				e.preventDefault()
				e.returnValue = ''
			}   
		},
		confirmLeave() {
			return window.confirm('Do you really want to leave? If you leave this page you will lose your unsaved changes.')
		}, 
		removeCommonSighting: function(sighting){
			sighting.details.count = '';
			sighting.details.specimen = false;
			sighting.details.photos = null;
			sighting.details.observer_confidence = 1;
			sighting.details.life_stage = 1;
		},
		removeExtraSighting: function(sighting){
			var index = this.extra_sightings.indexOf(sighting);
			if (index > -1) {
				this.extra_sightings.splice(index, 1);
			}
		},
		addExtraSighting: function(){
			this.extra_sightings.unshift({
				"key": Math.floor(Math.random() * 100000000),
				details:{
					specimen: false,
					photos: null,
					observer_confidence:1,
					life_stage: 1,
					needs_count:false,
				},
			});
		},
		getExtraCountClass:function(extra){
			var ret = 'entry-count';
			if (extra.details.needs_count && !extra.details.count) {
				ret += ' error-border';
			}
			return ret;
		},
		bindChecklist: function(then){
			var self = this;
			var qs = "&include[]=user.*";
			qs += "&include[]=location.*";
			qs += "&include[]=sightings.*";
			qs += "&include[]=sightings.taxon.*";
			var indexed_taxon = [];
			this.API({
				endpoint: 'checklists/' + this.$route.params.id,
				querystring: qs,
				funcThen: function(response){
					self.checklist = response.data.checklist;
					var tmp_projects = self.checklist.projects;
					self.checklist.projects = [];
					for (var i = 0; i < tmp_projects.length; i++) {
						self.checklist.projects.push(tmp_projects[i].id);
					}
					self.checklist_user = response.data.users.find(u => u.id == self.checklist.user);
					self.checklist_location = response.data.locations.find(l => l.id == self.checklist.location);

					for (var i = 0; i < self.checklist.sightings.length; i++) {
						self.checklist.sightings[i].taxon = response.data.taxa.find(t => t.id == self.checklist.sightings[i].taxon)
					}

					if (response.data.taxa) {
						indexed_taxon = response.data.taxa.reduce(function(map, obj) {
								map[obj.id] = obj;
								return map;
						}, {});
					}
					self.API({
						endpoint: 'locations/'+self.checklist_location.id+'/nearby_taxa',
						querystring: '&per_page=1000&include[]=family',
						funcThen: function(response){
							var list = [];

							for (var i = 0; i < response.data.taxa.length; i++) {
								list.push({
									taxon:response.data.taxa[i],
									details:{
										specimen: false,
										photos: null,
										observer_confidence:1,
										life_stage: 1,
									},
								});
							}
							self.create_lists(list, self.checklist.sightings, indexed_taxon)
							if (then) {
								then();
							}
						}
					});
				},
			});
		},
		create_lists:function(common_list, seen_list, seen_taxon){
			this.extra_sightings = [];
			this.common_list = common_list;
			for (var i = 0; i < seen_list.length; i++) {
				var found = false;
				if (seen_list[i].count == null) {
					seen_list[i].count = "X";
				}

				if (seen_list[i].common) {
					for (var j = 0; j < common_list.length; j++) {
						if (seen_list[i].taxon.id == common_list[j].taxon.id) {
							common_list[j] = this.merge_data(common_list[j], seen_list[i]);
							found = true;
						}
					}
				}

				
				if (!found) {
					var extra = this.merge_data(
						{
							taxon:seen_list[i].taxon
						},
						seen_list[i]
					);
					extra.key = extra.details.id;
					this.extra_sightings.push(extra);
				}
			}
		},
		errorClass(api_index){
			if (typeof api_index === 'undefined') {
				return "";
			}
			if (typeof this.api_errors.sightings[api_index] === 'undefined') {
				return "";
			}
			for (var property in this.api_errors.sightings[api_index]) {
					if (this.api_errors.sightings[api_index].hasOwnProperty(property)) {
						return " hasErrors";
					}
			}
			return "";
		},
		api_photo_to_vue: function(api_photo){
			return {
					"id": api_photo.id,
					"fileObject": true,
					"active": false,
					"success": true,
					"response": {
						"sighting_photo": api_photo
					},
					"progress": "100.00",
					"thumb": api_photo.small,
			};
		},
		merge_data: function(taxon, sighting){
			var ret = JSON.parse(JSON.stringify(taxon));
			ret.details = sighting;

			for (var i = 0; i < ret.details.photos.length; i++) {
				ret.details.photos[i] = this.api_photo_to_vue(ret.details.photos[i]);
			}
			if (sighting.type == 2) {
				ret.details.specimen = true;
			}
			return ret;
		},
		buildSighting: function(sighting, is_common){
			var count = parseInt(sighting.details.count);
			if (isNaN(count)) {
				count = null;
			}

			var photos = [];
			if (sighting.details.photos) {
				for (var i = 0; i < sighting.details.photos.length; i++) {
					if (sighting.details.photos[i].response.sighting_photo) {
						photos.push(sighting.details.photos[i].response.sighting_photo.id);
					}
				}
			}

			var ret = {
				"specimen": sighting.details.specimen ? true : false,
				"taxon": sighting.taxon ? sighting.taxon.id : null,
				"count": count,
				"notes": sighting.details.notes,
				"observer_confidence": sighting.details.observer_confidence,
				"life_stage": sighting.details.life_stage,
				"photos": photos,
				"institution": sighting.details.institution,
				"request_vetting": sighting.details.request_vetting,
				"common": is_common,
				"can_edit": sighting.details.can_edit,
			};

			if (sighting.inaturalist_id) {
				ret.inaturalist_id = sighting.inaturalist_id;
			}

			if (sighting.details.id > 0) {
				ret.id = sighting.details.id;
			}

			return ret;
		},
		buildChecklistToSave: function(checklist){
			if (checklist.has_another_observer) {
				if (checklist.observer == null) {
					checklist.observer = "";
				}
			}
			else{
				checklist.observer == null;
			}

			checklist.sightings = [];
			var index = 0;
			for (var i = 0; i < this.common_list.length; i++) {
				if (this.common_list[i].details.count != null && this.common_list[i].details.count != ""){
					checklist.sightings.push(this.buildSighting(this.common_list[i], true));
					this.common_list[i].api_index = index;
					index++;
				}
			}
			return checklist;
		},
		buildExtrasToSave: function(checklist){
			var index = checklist.sightings.length;
			for (var i = 0; i < this.extra_sightings.length; i++) {
				if (this.extra_sightings[i].details.count != null && this.extra_sightings[i].details.count != ""){
					checklist.sightings.push(this.buildSighting(this.extra_sightings[i], false));
					this.extra_sightings[i].api_index = index;
					index++;
				}
			}
			return checklist;
		},
		cancel:function(){
			this.$router.push({ name: 'profile', params: { id: this.checklist.user }});
		},
		validate:function(){
			var valid = true;
			for (var i = 0; i < this.extra_sightings.length; i++) {
				if (this.extra_sightings[i].taxon && !this.extra_sightings[i].details.count) {
					valid = false;
					this.extra_sightings[i].details.needs_count = true;
				}
				else{
					this.extra_sightings[i].details.needs_count = false;
				}
			}
			if (!valid) {
				this.$notify({
					title: 'Validation Error',
					text: 'Please review your data before saving again.',
					type: 'error',
				});
			}
			return valid;
		},
		deleteChecklist:function(){
			if (!confirm("Are you sure you want to permanently delete this checklist and it's records?")) {
				return;
			}
			var self = this;
			this.API({
				endpoint: 'checklists/' + this.$route.params.id,
				isDelete:true,
				funcThen: function(response){
					self.form_dirty = false;
					self.$notify({
						title: 'Checklist Deleted',
						type: 'success',
					});
					self.$router.push({ name: 'profile', params: { id: self.checklist.user }});
				},
				funcCatch: function(error){
					if (error.response && error.response.data) {
						self.notifyError(error.response.data);
					}
				}
			});
		},
		saveChecklist: function(redirectToProfile){
			var self = this;
			var cl = self.buildChecklistToSave(self.checklist);
			cl = self.buildExtrasToSave(cl);
			if (!this.validate()) {
				return;
			}

			var cleaned_checklist = JSON.parse(JSON.stringify(cl));
			if (cleaned_checklist.has_another_observer) {
				if (cleaned_checklist.observer == null) {
					cleaned_checklist.observer = "";
				}
			}
			else{
				cleaned_checklist.observer = null;
			}
			delete cleaned_checklist.has_another_observer;

			// var original_sightings = cleaned_checklist.sightings;
			// cleaned_checklist.sightings = [];

			// for (var i = 0; i < original_sightings.length; i++) {
			// 	if (original_sightings[i].can_edit !== false) {
			// 		cleaned_checklist.sightings.push(original_sightings[i]);
			// 	}
			// }
			
			var onSaveChecklist = function(){
				self.API({
					endpoint: 'checklists/' + self.$route.params.id,
					isPut:true,
					postData: cleaned_checklist,
					funcThen: function(response){
						self.form_dirty = false;
						self.$notify({
							title: 'Checklist Saved',
							type: 'success',
						});

						if (redirectToProfile) {
							self.$router.push({ name: 'profile', params: { id: response.data.checklist.user }});
						}
						else{
							self.bindChecklist();
							self.api_errors = {
								'sightings': []
							}
						}
					},
					funcCatch: function(error){
						var temp_api_errors = error.response.data;
						if (typeof temp_api_errors.sightings === 'undefined') {
							temp_api_errors.sightings = [];
						}

						self.api_errors = temp_api_errors;
						self.$nextTick(function () {
							self.scrollTo('.hasErrors, .errors');
						});
					}
				});
			}

			var onDeleteChecklist = function(){
				self.API({
					endpoint: 'checklists/' + self.$route.params.id,
					isDelete:true,
					funcThen: function(response){
						self.form_dirty = false;
						self.$notify({
							title: 'Checklist Deleted',
							type: 'success',
						});
						self.$router.push({ name: 'my-profile'});
					}
				});
			}

			if (self.checklist.sightings.length < 1) {
				self.$refs.deleteModalYesNo.setYes(onDeleteChecklist);
				self.$refs.deleteModalYesNo.setNo(onSaveChecklist);
				self.$refs.deleteModalYesNo.show();
			}
			else{
				onSaveChecklist();
			}
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/ChecklistEdit.vue